export enum CancellationReasonEnum {
  BANK_LOCK_EJECTED = 'BankLockRejected',
}
